/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Advantages_Sample_Citation_2Inputs */

const en_advantages_sample_citation_2 = /** @type {(inputs: Advantages_Sample_Citation_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Smith et al, 2021)`)
};

const es_advantages_sample_citation_2 = /** @type {(inputs: Advantages_Sample_Citation_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Smith et al, 2021)`)
};

/**
* | output |
* | --- |
* | "(Smith et al, 2021)" |
*
* @param {Advantages_Sample_Citation_2Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const advantages_sample_citation_2 = /** @type {((inputs?: Advantages_Sample_Citation_2Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Advantages_Sample_Citation_2Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_advantages_sample_citation_2(inputs)
	return en_advantages_sample_citation_2(inputs)
});